import script from "./CrudClientes.vue?vue&type=script&setup=true&lang=js"
export * from "./CrudClientes.vue?vue&type=script&setup=true&lang=js"

import "./CrudClientes.vue?vue&type=style&index=0&id=c7f59a88&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7f59a88"]])

export default __exports__